<template>
  <div style="max-width: 300px;" class="p-3">
    <p>Lorem ipsum dolor sit amet</p>
    <p>Suspendisse et nulla vel.</p>
    <p>Nunc at consectetur nibh.</p>
  </div>
</template>

<script>
export default {
  name: "LoremIpsum",
  mounted() {
  }
}
</script>

<style scoped>

</style>